import React from 'react';

class ToDoAddSearch extends React.Component{
    state={
        label:''
    }

    inputChange=(e)=>{
        this.props.todoSearch(e.target.value);
        this.setState({
            label: e.target.value
        });
    }
    formSubmit=(e)=>{
        e.preventDefault();
        this.props.addListItem(this.state.label);
    }
    render(){
        return(
            <form className="item-add-form d-flex todo-form" 
            onSubmit={this.formSubmit}
            >
            <input className="form-control search-input"
            placeholder="type to search"
            onChange={this.inputChange}
            />
        <button type="button"
                className="btn btn-sm btn-add-item"
                onClick={this.formSubmit}
                >
                  <i className="fa fa-plus" ></i>
            </button>
        </form>      
        );
    }
}


export default ToDoAddSearch;